const AboutSection = () => {
  return (
    <section id="about" className="section-padding bg-secondary">
      <div className="content-max">
        <h2 className="font-headline text-3xl sm:text-4xl md:text-5xl text-foreground tracking-tight mb-12 md:mb-16">
          From Structural Engineering
          <br />
          to Scaling Startups
        </h2>

        <div className="flex flex-col md:flex-row gap-12 md:gap-16">
          {/* Text column */}
          <div className="md:w-[65%] order-2 md:order-1">
            <div className="space-y-6 font-body text-base md:text-lg text-muted-foreground leading-relaxed">
              <p>
                I started my career as a structural engineer — designing systems
                that hold up under stress. After earning my MBA in Marketing, I
                spent the next decade applying that same systems-first mindset to
                growth.
              </p>
              <p>
                I helped scale Crunchyroll from a niche anime platform to{" "}
                <span className="font-mono text-sm md:text-base text-primary font-medium">
                  45M+ users
                </span>{" "}
                and{" "}
                <span className="font-mono text-sm md:text-base text-primary font-medium">
                  2M+ subscribers
                </span>
                , contributing to its{" "}
                <span className="font-mono text-sm md:text-base text-primary font-medium">
                  $1.2B acquisition
                </span>{" "}
                by Sony. I built the growth engine at Castle that helped secure a
                $15M seed round, growing MAU to 2.2M+ while cutting acquisition
                costs by 60%. As Head of Marketing at Sketchy, I drove 33% YoY revenue growth and
                built a large cross-functional growth team from scratch.
              </p>
              <p>
                In 2022, I co-founded SmartDreams — an AI-powered children's
                reading app that Apple named a Top AI App of 2023, alongside
                ChatGPT, Canva, and Pinterest. That experience pulled me deep
                into the AI ecosystem, and I haven't looked back.
              </p>
              <p>
                Today I'm the founder of Taylor Growth Consulting, where I
                  operate as a full-stack growth partner for consumer tech,
                  entertainment, and AI startups. I don't just advise — I operate.
                  And I don't just strategize — I build.
              </p>
            </div>

            {/* Pull quote */}
            <div className="mt-10 border-l-2 border-primary pl-6">
              <p className="font-headline text-xl md:text-2xl text-foreground italic">
                "I don't just advise — I operate."
              </p>
            </div>
          </div>

          {/* Headshot column */}
          <div className="md:w-[35%] order-1 md:order-2 flex justify-center md:justify-end md:items-start">
            <div className="w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 rounded-2xl overflow-hidden border border-border">
              <img
                src="/headshot.png"
                alt="Eric Taylor"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;